// 畫布-地址詳情側欄 文案 - 繁體中文
export default {
  header: {
    addressDetails: "地址詳情",
    contractDetails: "合約詳情",
  },
  loading: {
    text: "拼命加載中",
  },
  labels: {
    remark: "備註：",
    none: "暫無",
    otherInfo: "其他資訊",
    asset: "資產",
    tradingStatistics: "交易統計",
    transactionAnalysis: "交易分析",
    transactionDetails: "交易明細",
    tradingOpponent: "交易對手",
    labelMissing: "標籤缺失",
    dataLabel: "數據標籤",
    labelCorrect: "糾錯",
    labelTrace: "溯源",
  },
  tooltips: {
    edit: "編輯",
    addToMonitor: "加入監控",
    addToDashboard: "加入看板",
  },
  survey: {
    normal: "普通調證",
    important: "重點調證",
  },
  errors: {
    selectHint: "請在畫布中選擇節點或者交易邊可查看數據詳情",
    searchHintPrefix:
      "請在頂部搜索框內搜索地址/雜湊/調證用戶ID\n再選擇節點或者交易邊可查看數據詳情",
    unsupportedChain: "系統暫不支持此鏈上的數據展示",
    noData: "系統中沒有當前地址的交易數據",
    noAddressFound: "沒有查出該地址",
    dataNotFound: "未找到符合搜索內容的數據，請修正後重試",
  },
};
